import { useTranslation } from "utils/hooks/use-translation.hook";

import GoAiguaTooltip from "./goaiguatooltip";

type ApplicationItemProps = {
    icon: any;
    title: string;
    className?: string;
    url?: string;
    color?: string;
    available: boolean;
    allowed: boolean;
};

const ApplicationItem = ({
    icon,
    title,
    className,
    url,
    color,
    available,
    allowed,
}: ApplicationItemProps) => {
    const translate = useTranslation();

    const handleAppClick = () => {
        if (!available || !url || !window) return;

        window.open(url, "_blank")?.focus();
    };

    return (
        <div
            className={
                "c-application-item" +
                (!allowed ? " --no-access" : "") +
                (!available ? " --no-available" : " --available")
            }
            onClick={handleAppClick}
        >
            {!available && (
                <GoAiguaTooltip
                    text={translate(
                        allowed
                            ? "app.application.NoAccess"
                            : "app.application.NoProduct"
                    )}
                />
            )}

            <div
                style={{ backgroundColor: color }}
                className={
                    `c-application-item__icon-circle ${className}` +
                    (!allowed ? " --no-available-icon" : "")
                }
            >
                {icon}
            </div>

            <div
                className={
                    "c-application-item__application-title" +
                    (!available ? " --no-available-text" : "")
                }
            >
                {title}
            </div>
        </div>
    );
};

export default ApplicationItem;
